import { render, staticRenderFns } from "./selectScale.vue?vue&type=template&id=5036b352&scoped=true"
import script from "./selectScale.vue?vue&type=script&lang=js"
export * from "./selectScale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5036b352",
  null
  
)

export default component.exports